<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app>
      <template v-slot:prepend>
        <v-toolbar class="theme--dark">
          <img
            :style="{
              'max-width': $vuetify.breakpoint.smAndDown ? '100px' : '200px',
              'max-height': '48px',
              cursor: 'pointer',
            }"
            class="mr-1"
            @click="$router.push('/')"
            aspect-ratio="1.0"
            :src="
              `https://sga-assets.s3-sa-east-1.amazonaws.com/domains/${domain}/img/logo.png`
            "
            :alt="domain"
          />
          <!-- <v-toolbar-title class="pl-2">{{ domain }}</v-toolbar-title> -->
        </v-toolbar>
      </template>

      <DrawerList />
    </v-navigation-drawer>

    <DrawerProfile />

    <v-app-bar app>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>{{ $route.meta.nameDrawer }}</v-toolbar-title>
      <v-spacer></v-spacer>

      <!-- <BtnLanguages /> -->

      <!-- Button Notification -->
      <v-btn
        v-if="level === 'administrator'"
        icon
        class="btn-notification"
        @click="
          $route.name !== 'AdministratorSystemNotifications' &&
            $router.push({ name: 'AdministratorSystemNotifications' })
        "
      >
        <span class="qtd-notification" v-show="notificationCounter > 0">
          {{ notificationCounter }}
        </span>
        <v-icon>mdi-bell-outline</v-icon>
      </v-btn>

      <!-- Button Logout -->
      <v-btn icon @click="doLogout">
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main :class="$vuetify.theme.dark ? '' : 'grey lighten-4'">
      <Breadcrumb />
      <TabsNavigationButtons />
      <SubTabsNavigationButtons />
      <FiltersWrap />
      <v-container :fluid="mainContainerFluid">
        <router-view></router-view>
      </v-container>
    </v-main>

    <!-- <v-footer app>
        <span>&copy; {{ new Date().getFullYear() }}</span>
    </v-footer>-->
  </v-app>
</template>

<script>
import Breadcrumb from "@/components/common/breadcrumb/Breadcrumb";
import DrawerList from "@/components/common/drawer/DrawerList";
import DrawerProfile from "@/components/common/drawer/DrawerProfile";
import FiltersWrap from "@/components/common/filters/FiltersWrap";
import TabsNavigationButtons from "@/components/common/Tabs/TabsNavigationButtons";
import SubTabsNavigationButtons from "@/components/common/Tabs/SubTabsNavigationButtons";
// import BtnLanguages from "@/components/btn-languages/btn-languages";

import logout from "@/util/logout";
export default {
  name: "Backoffice",
  components: {
    DrawerList,
    Breadcrumb,
    DrawerProfile,
    FiltersWrap,
    TabsNavigationButtons,
    SubTabsNavigationButtons,
    // BtnLanguages,
  },
  data: () => ({
    drawer: null,
    domain: localStorage.getItem("operator"),
    level: "",
  }),
  async mounted() {
    this.level = localStorage.getItem("level");
    if (this.level === "administrator") {
      const request = await this.$request.get(
        "/administrator/notifications/countNewsNotifications"
      );

      this.$store.commit("setNotificationCounter", request.dados);
    }
  },
  computed: {
    mainContainerFluid() {
      return this.$store.state.mainContainerFluid;
    },
    notificationCounter() {
      return this.$store.state.notificationCounter;
    },
  },
  methods: {
    doLogout() {
      logout();
    },
  },
};
</script>

<style>
.btn-notification {
  position: relative;
}

.btn-notification .qtd-notification {
  position: absolute;
  top: -10px;
  right: 3px;
  padding: 0 4px;
  border-radius: 50%;
  background-color: red;
}
</style>
